var GoToCar = (function() {
	var __private = {
		url      : "/ajax/item/check-for-sale-sign-code/",

		href     : "/public/",
		
		formID   : "gotocar",
		inputID  : "code",
		buttonID : "go",
		errorID  : "codeError",
		errorMsg : "The code does not exist or the requested listing is not public.",
		disClass : "disabled",

		listeners() {
			this.formListener();
			this.noSubmit();
			this.buttonListener();
		},

		formListener() {
			var form = document.getElementById(this.formID);

			if(form instanceof HTMLFormElement) {
				form.addEventListener("keydown", function(event) {
					event = event || window.event;
					var key = event.keyCode; // '13' - Enter
					
					if(key === 13) {
						event.preventDefault();

						__private.request();
					}
				});
			}
		},

		buttonListener() {
			var button = document.getElementById(this.buttonID);

			if(button instanceof HTMLElement) {
				button.addEventListener("click", function(event) {
					event = event || window.event;
					event.preventDefault();

					if(!this.classList.contains(__private.disClass)) __private.request();
				});
			}
		},

		request() {
			var xhr = new XMLHttpRequest();
			var listingID = __private.getListingID();
			var url = __private.getULR(listingID);

			if(url) {
				xhr.open("GET", url, true);
				xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
				xhr.send();
				xhr.onreadystatechange = function() {

					__private.btnDisabled(true);

					if (this.readyState === 4) {
						if (this.status === 200) {
							let answer = JSON.parse(this.responseText);
	
							if(answer && answer.hasOwnProperty("url")) window.location.href = answer.url;
							else __private.error(true);
						} else {
							if(this.status >= 400) {
								console.log("Error " + this.status);
								__private.error(true);
							}
						}
					}

					setTimeout(() => __private.btnDisabled(false), 500);
				};
				xhr.onerror = function() {
					console.error("GoToCar error: " + this.status);
				}
			}
		},

		getListingID() {
			var input  = document.getElementById(this.inputID);
			var ID = null;

			if(input instanceof HTMLInputElement) ID = input.value;

			return ID;
		},

		getULR(ID) {
			if(ID && ID !== null) return `${this.url}${ID}`;
			else return false;
		},

		noSubmit() {
			var form = document.getElementById(this.formID);

			if(form instanceof HTMLFormElement) form.addEventListener("submit", function(event) {
				event = event || window.event;
				event.preventDefault();
			});
		},

		btnDisabled(flag) {
			var button = document.getElementById(this.buttonID);

			if(button instanceof HTMLElement) {
				if(flag) button.classList.add(this.disClass);
				else button.classList.remove(this.disClass);
			}
		},

		error(flag) {
			var errElem = document.getElementById(this.errorID);

			if (errElem instanceof HTMLElement) {
				
				if(flag) errElem.textContent = this.errorMsg;
				else errElem.textContent = "";
			}
		}
	};

	return {
		init() {
			__private.listeners();
		}
	};
})();


(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var form = document.getElementById("gotocar");

		if(form instanceof HTMLElement) GoToCar.init();
	});
})();